import axios from 'axios';

const API_URL = process.env.REACT_APP_BASEURL + 'course';
const API_URL2 = process.env.REACT_APP_BASEURL + 'content';

export const getAllCourseAndSection = async (reqData: any) => {
  return axios.get(`${API_URL}/courseDetails`, { params: reqData });
};
export const getAllCourse = async (reqData: any, signal?: any) => {
  return axios.get(`${API_URL}/allOrg`, { params: reqData, signal });
};

export const getTabCount = async (reqData: Object, signal?: any) => {
  return axios.get(`${API_URL}/getTabCount`, { params: reqData, signal });
};

export const getAllFreeCourse = async (reqData: any) => {
  return axios.get(`${API_URL}/allfreeOrg`, { params: reqData });
};

export const getAllCourseByCategory = async (reqData: any) => {
  return axios.get(`${API_URL}/getListByCategory`, { params: reqData });
};

export const getUserRelatedCourses = async (reqData: any) => {
  return axios.get(`${API_URL}/relatedCourses`, { params: reqData });
};

export const getAllCourseEdit = async (courseId: any) => {
  return axios.get(`${API_URL}?courseId=${courseId}`);
};

export const getAllLogs = async (userId: any) => {
  return axios.get(`${API_URL}/userActivity/all?userId=${userId}`);
};

export const getFacultyCourse = async (reqData: any) => {
  return axios.get(`${API_URL}/all`, { params: reqData });
};

export const addCourse = (reqData: object) => {
  return axios.post(API_URL + '/add', reqData);
};

export const addCourseField = (updateGroup: Object) => {
  return axios.put(API_URL + '/add_fields', updateGroup); // reqData => {search: "text", limit: number, skip: limit}
};

export const removeCourseField = (updateGroup: Object) => {
  return axios.put(API_URL + '/remove_fields', updateGroup); // reqData => {search: "text", limit: number, skip: limit}
};

export const getCourse = (reqData: object) => {
  return axios.get(API_URL, { params: reqData });
};

export const getSuperAdminCreatedCourses = () => {
  return axios.get(`${API_URL}/getSuperAdminCreatedCourses`);
};

export const courseRequest = (reqData: Object) => {
  return axios.put(`${API_URL}/courseRequest`, reqData);
};

export const editCourse = (reqData: object) => {
  return axios.put(API_URL, reqData);
};
export const courseRearrange = (reqData: object) => {
  return axios.put(API_URL + '/rearrange', reqData);
};
export const deleteCourse = (reqData: object) => {
  return axios.delete(API_URL, { data: reqData });
};

export const getCourseDetails = (reqData: object) => {
  return axios.get(`${API_URL}/courseInfo`, { params: reqData });
};

export const getCourseReview = (reqData: object) => {
  return axios.get(`${API_URL}/courseReview`, { params: reqData });
};

export const getCourseFaq = (reqData: object) => {
  return axios.get(`${API_URL}/courseFaq`, { params: reqData });
};

export const getCourseCreatedDetails = (reqData: object) => {
  return axios.get(`${API_URL}/courseCreatedInfo`, { params: reqData });
};

export const uploadCourseFiles = (reqData: object) => {
  return axios.post(`${API_URL}/files`, reqData);
};

export const downloadCourseFiles = (reqData: object) => {
  return axios.get(`${API_URL}/download`, {
    params: reqData,
    responseType: 'blob'
  });
};

export const downloadContentFiles = (reqData: object) => {
  return axios.get(`${API_URL2}/downloadFile`, {
    params: reqData,
    responseType: 'blob'
  });
};

export const downloadSingleFile = (reqData: object) => {
  return axios.get(`${API_URL}/downloadFile`, {
    params: reqData,
    responseType: 'blob'
  });
};

export const getFiles = (reqData: object) => {
  return axios.get(`${API_URL}/files`, { params: reqData });
};

export const deleteSingleFile = (reqData: object) => {
  return axios.delete(`${API_URL}/files`, { data: reqData });
};

export const addFavoriteCourse = async (reqData: any) => {
  return axios.patch(`${API_URL}/favorite`, reqData);
};

export const getAllUserFavoriteCourses = async (reqData: any) => {
  return axios.get(`${API_URL}/favorite`, { params: reqData });
};

export const uploadVideo = async (reqData: Object) => {
  return await axios.post(API_URL + '/uploadVideo', reqData);
};

export const deleteCourseVideo = (fileId: string) => {
  return axios.delete(`${API_URL}/deleteCourseVideo/${fileId}`);
};
export const getGroupsAndUsersByCourse = async (reqData: any) => {
  return axios.get(`${API_URL}/getGroupsAndUsersByCourse`, { params: reqData });
};

export const getAllCoursesSA = async () => {
  return axios.get(`${API_URL}/`);
};
export const addCurseSA = (reqData: object) => {
  return axios.post(API_URL + '/createDefaultCourse', reqData);
};
export const updateCourseSA = (updateGroup: Object) => {
  return axios.put(API_URL + '/updateDefaultCourse', updateGroup);
};

export const publishUnpublish = (reqData: object) => {
  return axios.patch(API_URL + '/publish-unpublish', reqData);
};

export const downloadCourseListCsv = (reqData: Object) => {
  return axios.get(API_URL + '/downloadCourseList', { params: reqData, responseType: 'blob' });
};

export const getPublicCourseDetails = (reqData: object) => {
  return axios.get(`${API_URL}/publicCourseInfo`, { params: reqData });
};

export const getPublicCourseReview = (reqData: object) => {
  return axios.get(`${API_URL}/publicCourseReview`, { params: reqData });
};

export const getPublicCourseFaq = (reqData: object) => {
  return axios.get(`${API_URL}/publicCourseFaq`, { params: reqData });
};

export const getPublicCourseCreatedDetails = (reqData: object) => {
  return axios.get(`${API_URL}/publicCourseCreatedInfo`, { params: reqData });
};

// export const getCoursesByOrgSlug = async (reqData: any, signal?: any) => {
//   return axios.get(`${API_URL}/by-org-slug/${reqData.slug}`, { signal });
// };


